<style>
    .ly-product-total{
        border:1px solid #dfe6ec;
        border-top: 0;
        
    }
    .ly-product-total-item{
        color: #48576a;
        font-size: 14px;
        padding: 8px 12px;
        border-left: 1px solid #dfe6ec;   
    }
</style>
<template>
    <div class="p20" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">修改三包理赔单</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="addQuote" size="small">
                    选择引用登记单
                </el-button>
                <el-button type="primary"
                    :disabled="submitForm.status == 11 ? true : false" 
                    @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard" v-if="!loading"> 
            <ly-product-table 
                ref="productTable"
                v-model="submitForm.productList"
                :is-add="false"
                :is-delete="false"
                :thead-config="productConfig">
                <el-col :span="24" class="ly-product-total">
                    <el-col :offset="12" :span="6" class="ly-product-total-item">
                        总贴损金额: {{totalTiesunAmount}}
                    </el-col>
                    <el-col :span="6" class="ly-product-total-item">
                        总理赔金额: {{totalLipeiAmount}}
                    </el-col>
                </el-col>
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
        <Ly-quote ref="tgquote" 
            register-id="submitForm.dengji_id" 
            ref-id="submitForm.guanlian_transaction_no" 
            @complete="quoteComplete"></Ly-quote>
    </div>
</template>
<script>
    /**
     * 三包理赔的修改页面
     * @author zjs
     * @time 2017-09-18
     */
    import EditConfig from './edit-form'
    import AddProductConfig from './add-product'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import LyRouterButton from '@c/router-button'
    import LyQuote from '@c/quote'
    export default {
        mixins: [
            EditConfig, 
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyProductTable,
            LyRouterButton,
            LyQuote
        },
        data () {
            return {
                loading: true,
                submitLoad: false, // 提交按钮的状态标识
                infoId: 0, // 详情的ID
                submitForm: {}, // 详情的数据
                totalLipeiAmount: 0 // 总的理赔金额
            }
        },
        computed: {
            // 总的贴损金额，顺便将总的理赔金额 在这计算了
            totalTiesunAmount () {
                let total = 0 
                let lipei = 0
                this.submitForm.productList.forEach(function (el) {
                    // 计算总的贴损金额
                    if (el.tiesun_amount && !isNaN(el.tiesun_amount)) {
                        total = (parseFloat(total) + parseFloat(el.tiesun_amount)).toFixed(2)
                    }
                    // 计算理赔总金额
                    if (el.lipei_amount && !isNaN(el.lipei_amount)) {
                        lipei = (parseFloat(lipei) + parseFloat(el.lipei_amount)).toFixed(2)
                    }
                }, this)
                this.totalLipeiAmount = lipei
                return total
            }
        },
        created () {
            this.init()
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'CheckoutEdit') {
                    this.init()
                }
            }
        },
        methods: {
            init () {
                // 获取详情的ID
                this.infoId = this.$route.params.id
                if (this.infoId) {
                    this.queryEditData()
                } else {
                    this.$message({
                        message: '无ID',
                        type: 'warning'
                    })
                }
            },
            addQuote () {
                this.$refs['tgquote'].open();
            },
            /** 
            * 引用单号的选择
            */
            quoteComplete (quote) {
                this.$refs['searchForm'].initBindFormData(quote)
                // quote.productList.forEach((el) => {
                //     console.log('el:%O', el)
                // })
                // 设置货品回填
                this.$refs['productTable'].replaceProductList(quote.productList)
            },
            /**
             * 获取要修改的数据
             */
            queryEditData () {
                this.$api.queryArr(['api/sanbaoLp', 'edit'], null, [this.infoId]).then((rs) => {
                    this.submitForm = rs
                    // 设置表单中的回填数据
                    this.$refs['searchForm'].initBindFormData(rs)
                    // 设置UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                    // 取消加载
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                }).catch((error) => {
                    // 取消加载
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            submit () {
                let productList = this.submitForm['productList']
                if (this.$refs['searchForm'].validateForm()) {
                    if (productList && productList.length > 0) {
                        // 设置要提交的数据
                        var data = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                        // 货品验证
                        let productMsg = this.validateProduct(productList, data.lipei_manner)
                        // 货品验证不通过的情况
                        if (productMsg.length > 0) {
                            this.$alert(productMsg, '货品录入提示', {
                                confirmButtonText: '确定'
                            })
                        } else {
                            this.submitLoad = true
                            // 表单中写入货品列表
                            data['productList'] = productList
                            // 提交数据
                            this.$api.save('api/sanbaoLp/' + this.infoId, data).then((rs) => {
                                this.$alert('数据提交成功', '修改', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        this.submitLoad = false
                                        // 跳转到详情页面
                                        this.$router.push('/bill/checkout/info/' + this.infoId)
                                    }
                                });
                                // 更新UUID
                                this.submitForm.uuid = this.$utils.createUUID()
                            }).catch((error) => {
                                this.submitLoad = false
                                this.$message({
                                    message: error,
                                    type: 'warning'
                                })
                            })
                        }
                    } else {
                        this.$message({
                            message: '请添加货品',
                            type: 'warning'
                        })
                    }
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>